<template>
    <div :class="[{'border-bottom': bottom},
                  {'border-top': top},
                  {'border-right': right},
                  {'border-left': left}]">
        <slot />
    </div>
</template>

<script>
export default {
  name: "Border",
  props: {
    top: {
      type: Boolean,
      default: false
    },
    right: {
      type: Boolean,
      default: false
    },
    bottom: {
      type: Boolean,
      default: false
    },
    left: {
      type: Boolean,
      default: false
    }
  }
}
</script>

<style scoped lang="sass">
    .border-bottom
        border-bottom: 1px #e2e2e2 solid
    .border-top
        border-top: 1px #e2e2e2 solid
    .border-right
        border-right: 1px #e2e2e2 solid
    .border-left
        border-left: 1px #e2e2e2 solid
</style>
